import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { HideUserSettingsAction } from '../../../domains/hideUsers/settingsActions.types';

import type { NetworkHideUserSettings } from './types';

export type NetworkHideUserSettingsAction = HideUserSettingsAction;
const initialState: NetworkHideUserSettings = {
  pending: false,
  fulfilled: undefined,
  rejected: null,
};

const reducer: Reducer<NetworkHideUserSettings, NetworkHideUserSettingsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'NETWORK_SETTINGS.LOAD_HIDE_USER_SETTINGS_PENDING':
      return setPending();
    case 'NETWORK_SETTINGS.LOAD_HIDE_USER_SETTINGS_FULFILLED':
      return setFulfilled(action.payload);
    case 'NETWORK_SETTINGS.LOAD_HIDE_USER_SETTINGS_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
